import "./index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import theme from "./theme";
import { ThemeProvider } from "styled-components";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import { Toast } from "antd-mobile";


axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    if(config.loading !== undefined && config.loading){
      Toast.loading('提交中...', 0)
    }
    
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    Toast.hide()
    return response;
  }, function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
  });
ReactDOM.render(
    <ThemeProvider theme={theme}>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename="/wap">
                    <App />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </ThemeProvider>,
    document.getElementById("root")
);

// module.hot && module.hot.accept();



// WEBPACK FOOTER //
// ./src/index.js


// WEBPACK FOOTER //
// ./src/index.js